export default __webpack_public_path__ + "static/media/phylogeny.799ec35f.png";